import { render, staticRenderFns } from "./PlatformResalePricesComponent.vue?vue&type=template&id=6d0176db&"
import script from "./PlatformResalePricesComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformResalePricesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports